"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "19", height: "19", viewBox: "0 0 19 19", className: "Icon nav-help", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M8.19 13.63h1.48v-1.492H8.19zM9.024 4.25c-.767 0-1.408.211-1.907.626-.505.42-.754.986-.741 1.681 0 .294.143.85.683.85.538 0 .695-.53.704-.813 0-.368.117-.638.359-.825.246-.191.549-.287.902-.287.405 0 .719.109.933.325.213.215.322.532.322.942 0 .348-.082.647-.245.89-.172.258-.464.631-.86 1.099-.438.396-.702.708-.807.955-.106.247-.16.668-.164 1.288l-.001.101h1.426v-.1c0-.366.022-.638.067-.807.043-.16.172-.348.38-.557.484-.467.879-.93 1.174-1.378.3-.458.454-.97.454-1.522 0-.771-.24-1.383-.71-1.817-.468-.432-1.131-.651-1.97-.651" }),
            _react2.default.createElement("path", { d: "M16.755 9.025c0 4.262-3.467 7.73-7.73 7.73-4.262 0-7.73-3.468-7.73-7.73 0-4.262 3.468-7.73 7.73-7.73 4.263 0 7.73 3.468 7.73 7.73M9.025 0C4.05 0 0 4.049 0 9.025c0 4.977 4.049 9.025 9.026 9.025 4.976 0 9.024-4.048 9.024-9.025C18.05 4.049 14.002 0 9.026 0" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/nav-help.js
// module id = 1867
// module chunks = 0